import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllTemplates = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/inbursa/templates', options);
};

const getTemplateById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/inbursa/templates/code/' + dataClientId, options);
};

const createTemplate = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/inbursa/templates', dataClient, options);
};

const updateTemplate = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/inbursa/templates/' + dataClientId, dataClient, options);
};

const deleteTemplate = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/inbursa/templates/' + dataClientId, options);
};

const uploadImagesTemplate = (idTemplate, dataImages) => {
  let {NERTHUS, options} = ConfigAxios();
  let auth = options.headers.Authorization;
  let optionsZip = {
    headers: {
        'Authorization': auth
        
    }}
  return axios.post(NERTHUS + '/inbursa/templates/upTemplateImages/'+ idTemplate, dataImages, optionsZip);
};

const uploadImageDefault = (idTemplate, dataImages) => {
  let {NERTHUS, options} = ConfigAxios();
  let auth = options.headers.Authorization;
  let optionsZip = {
    headers: {
        'Authorization': auth
        
    }}
  return axios.post(NERTHUS + '/inbursa/templates/upImageDefault/'+ idTemplate, dataImages, optionsZip);
};

const InbursaTemplateCrudService = {
  getAllTemplates,
  getTemplateById,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  uploadImagesTemplate,
  uploadImageDefault
};

export default InbursaTemplateCrudService;